<ion-text>
  <p class="font-text">
    O projeto de regularização foi registrado em cartório no dia
    <b>{{ notificacao?.payload?.cartorioRegistroData | date: 'dd/MM/yyyy' }}</b>. Acompanhe notícias sobre a eventual
    emissão do seu título de propriedade e evento de distribuição através dos nossos canais oficiais de comunicação.
  </p>
</ion-text>
